import { ObjectLike } from '@/types/objectlike.types';
import {
  iReview,
  iLike,
  iComment,
  iShare,
} from './review.types';

export class Review implements iReview {
  readonly id: string;

  readonly text: string;

  readonly rating: number;

  readonly gameId: number;

  readonly gameName: string;

  readonly userId: string;

  readonly gamertag: string;

  readonly createdAt: number;

  readonly likes: iLike[];

  readonly comments: iComment[];

  readonly share?: iShare;

  constructor(
    id: string,
    text: string,
    rating: number,
    gameId: number,
    gameName: string,
    userId: string,
    gamertag: string,
    createdAt: number,
    likes?: iLike[],
    comments?: iComment[],
    share?: iShare,
  ) {
    this.id = id;
    this.text = text;
    this.rating = rating;
    this.gameId = gameId;
    this.gameName = gameName;
    this.userId = userId;
    this.gamertag = gamertag;
    this.createdAt = createdAt;
    this.likes = likes || [];
    this.comments = comments || [];
    this.share = share;
  }

  toObject(): ObjectLike {
    /**
     * Likes, Comments and share shall not return here
     * Because they belongs to another entity on firestoer
     * */
    return {
      id: this.id,
      text: this.text,
      rating: this.rating,
      gameId: this.gameId,
      gameName: this.gameName,
      userId: this.userId,
      gamertag: this.gamertag,
      share: this.share ? this.share.toObject() : {},
      createdAt: this.createdAt,
    };
  }
}
